import { useDataFetchingClient } from 'data-fetching-client';
import { useCallback } from 'react';
import { GET_ITEMS_QUERY as GET_ITEMS_QUERY_PUBLIC } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/CollectionsPublicRpc.dfc.new';
import { GET_ITEMS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/CollectionsRpc.dfc.new';
export function useThemeCollectionItems({
  appContext,
  collectionId
}) {
  const isPublic = appContext === 'public';
  const client = useDataFetchingClient();
  const fetchThemeCollectionItemIds = useCallback(() => {
    if (!collectionId) {
      return Promise.resolve([]);
    }
    const query = isPublic ? GET_ITEMS_QUERY_PUBLIC : GET_ITEMS_QUERY;
    return client.query({
      query,
      variables: {
        collectionId
      }
    }).then(({
      data
    }) => {
      var _data$result, _items$offeringIds;
      const items = (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.items;
      return (_items$offeringIds = items === null || items === void 0 ? void 0 : items.offeringIds) !== null && _items$offeringIds !== void 0 ? _items$offeringIds : [];
    });
  }, [client, collectionId, isPublic]);
  return {
    fetchThemeCollectionItemIds
  };
}